/** Ported from haulsheet index.html ocrParseTsDetail (Truckstop load page). */
import { OCR_EQUIP, ocrBlankLoad, ocrClearFilledWarnings, ocrIsState, ocrLines, ocrNum, ocrPlacesFromRowText, } from "./shared.js";
export function ocrParseTsDetail(lines, words) {
    const all = lines.map((l) => l.text).join("\n");
    if (!/Posted Rate/i.test(all) || !/Equipment/i.test(all))
        return [];
    const post = words.filter((w) => /^POSTING$/i.test(w.t))[0];
    const intn = words.filter((w) => /^INTERNAL$/i.test(w.t))[0];
    const originW = words.filter((w) => /^Origin$/i.test(w.t))[0];
    let maxX = 0;
    words.forEach((w) => {
        maxX = Math.max(maxX, w.x + w.w);
    });
    /* POSTING COMPANY under the cities is the same column on a phone. Only cut a side column when POSTING sits clearly to the right of Origin. */
    const side = !!(post && originW && post.x > originW.x + Math.max(originW.w || 0, 40) + 24);
    const cut = side ? post.x - (post.h || 8) : maxX + 1;
    const left = ocrLines(words.filter((w) => w.x + w.w / 2 < cut));
    const text = left.map((l) => l.text).join("\n");
    function g(re, n) {
        const m = text.match(re);
        return m ? String(m[n || 1]).trim() : "";
    }
    const L = ocrBlankLoad();
    L.linehaul = ocrNum(g(/Posted Rate\s*\$?([\d,]+(?:\.\d\d)?)/));
    if (!L.linehaul) {
        const rateAll = all.match(/Posted\s*Rate\s*\$?\s*([\d,]+(?:\.\d\d)?)/i);
        if (rateAll)
            L.linehaul = ocrNum(rateAll[1]);
    }
    if (!L.linehaul)
        L.unreadable.push("Posted rate could not be read");
    L.miles = ocrNum(g(/Miles\s*([\d,]+)/));
    if (!L.miles) {
        const milesAll = all.match(/\bMiles\s*([\d,]+)/i);
        if (milesAll)
            L.miles = ocrNum(milesAll[1]);
    }
    function placeOnLine(raw) {
        const t = String(raw || "")
            .replace(/,/g, ", ")
            .replace(/\s+/g, " ")
            .trim();
        let m = t.match(/([A-Za-z][A-Za-z .'\-]{1,40}?)\s*,\s*([A-Z]{2})\b(?:\s*(\d{5}))?/);
        if (m && ocrIsState(m[2])) {
            return m[1].replace(/\s+/g, " ").trim() + ", " + m[2] + (m[3] ? " " + m[3] : "");
        }
        m = t.match(/([A-Za-z][A-Za-z .'\-]{1,40}?)\s+([A-Z]{2})\s+(\d{5})\b/);
        if (m && ocrIsState(m[2])) {
            return m[1].replace(/\s+/g, " ").trim() + ", " + m[2] + " " + m[3];
        }
        return "";
    }
    function cityAfter(label, pool) {
        const use = pool || left;
        let i = -1;
        use.forEach((l, n) => {
            if (i < 0 && new RegExp("^\\W*" + label + "\\b", "i").test(l.text))
                i = n;
        });
        if (i < 0) {
            use.forEach((l, n) => {
                if (i < 0 && new RegExp("\\b" + label + "\\b", "i").test(l.text))
                    i = n;
            });
        }
        if (i < 0)
            return "";
        for (let n = i; n < Math.min(use.length, i + 6); n++) {
            if (n > i && /^POSTING\b/i.test(use[n].text))
                break;
            let line = use[n].text;
            if (n === i)
                line = line.replace(new RegExp("^\\W*" + label + "\\b", "i"), "");
            const hit = placeOnLine(line);
            if (hit)
                return hit;
        }
        return "";
    }
    L.origin = cityAfter("Origin", left) || cityAfter("Origin", lines);
    L.destination = cityAfter("Destination", left) || cityAfter("Destination", lines);
    if (!L.origin || !L.destination) {
        const lane = all.match(/([A-Za-z][A-Za-z .'\-]{1,40}?,\s*[A-Z]{2})\s+(?:to|\u2192|->|\u2013|\u2014)\s+([A-Za-z][A-Za-z .'\-]{1,40}?,\s*[A-Z]{2})/i);
        if (lane) {
            if (!L.origin)
                L.origin = lane[1].replace(/\s+/g, " ").trim();
            if (!L.destination)
                L.destination = lane[2].replace(/\s+/g, " ").trim();
        }
    }
    if (!L.origin || !L.destination) {
        const blobPlaces = ocrPlacesFromRowText(all);
        if (!L.origin && blobPlaces[0])
            L.origin = blobPlaces[0];
        if (!L.destination && blobPlaces[1])
            L.destination = blobPlaces[1];
    }
    if (!L.origin)
        L.unreadable.push("Origin could not be read");
    if (!L.destination)
        L.unreadable.push("Destination could not be read");
    ocrClearFilledWarnings(L);
    const pu = g(/Pick-?up\s+(.+)/);
    const pu2 = g(/Date\/Time\s+(.+)/);
    L.pickup = (pu + " " + pu2).trim();
    const eq = g(/Equipment\s+([A-Z]{1,5})\b/);
    L.equipment = OCR_EQUIP[eq] || (eq ? eq + " (board code)" : "");
    L.weight = ocrNum(g(/Weight\s+([\d,]+)/));
    L.pieces = g(/Quantity\s+(\d+)/);
    ["Length", "Width", "Height"].forEach((k) => {
        const v = g(new RegExp(k + "\\s+([\\d.]+)\\s*ft"));
        const key = k.toLowerCase();
        L[key] = v ? v + " ft" : "";
        if (!v)
            L.unreadable.push(k + " is not on the posting");
    });
    const mode = g(/Mode\s+([A-Z]{2,3})\b/);
    const stops = g(/Stops\s+(\d+)/);
    let si = -1;
    left.forEach((l, n) => {
        if (/Special Information/i.test(l.text))
            si = n;
    });
    const special = si >= 0
        ? left
            .slice(si + 1)
            .map((l) => l.text)
            .join(" ")
            .trim()
        : "";
    const mid = post
        ? ocrLines(words.filter((w) => w.x >= post.x - post.h && (!intn || w.x + w.w < intn.x - intn.h)))
        : [];
    let company = "";
    let phase = 0;
    mid.forEach((l) => {
        if (phase === 0 && /POSTING/.test(l.text)) {
            phase = 1;
            return;
        }
        if (phase === 1 && /Rating|First|Call|Feedback|Contact/i.test(l.text))
            phase = 2;
        if (phase === 1)
            company += (company ? " " : "") + l.text;
    });
    const midText = mid.map((l) => l.text).join("\n");
    const mc = (midText.match(/Broker MC\s+(\d+)/) || [])[1];
    const phone = (all.match(/\b(\d{3}-\d{3}-\d{4})\b/) || [])[1];
    L.ref =
        "Truckstop" +
            (company ? ", " + company : "") +
            (mc ? ", broker MC " + mc : "") +
            (phone ? ", " + phone : "");
    const notes = [];
    if (mode)
        notes.push("Mode: " + mode);
    if (stops)
        notes.push("Stops: " + stops);
    if (special)
        notes.push("Special information: " + special);
    L.notes = notes.join(". ");
    L.unreadable.push("Delivery date is not on the posting");
    L.unreadable.push("Commodity is not on the posting unless it is in the special information");
    return [L];
}
//# sourceMappingURL=truckstop_detail.js.map